import { render, staticRenderFns } from "./LuckLayer.vue?vue&type=template&id=270cf067&scoped=true&"
import script from "./LuckLayer.vue?vue&type=script&lang=js&"
export * from "./LuckLayer.vue?vue&type=script&lang=js&"
import style0 from "./LuckLayer.vue?vue&type=style&index=0&id=270cf067&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cf067",
  null
  
)

export default component.exports